import React, { useEffect, useState } from 'react';
import NotificationFeed from './NotificationFeed';
import { useSelector, useDispatch } from "react-redux";
import { loadSeller } from "../redux/actions/user";
import { setNotificationSidebarOpen } from "../state/uiSlice";
import SharedRightSlideout from './Layout/SharedRightSlideout';
import UserInbox from '../pages/UserInbox';

export default function NotificationSidebar() {
  const [isMessagesModalOpen, setIsMessagesModalOpen] = useState(false);
  const isNotificationSidebarOpen = useSelector((state) => state.ui.isNotificationSidebarOpen);
  const currentProfile = useSelector((state) => state.user.currentProfile);
  const { user } = useSelector((state) => state.user);
  const seller = useSelector((state) => state.seller.seller || state.seller.activeSeller);
  const userId = user?._id;
  const sellerId = seller?._id;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadSeller());
  }, [dispatch]);

  const getCurrentProfileType = () => {
    return currentProfile === 'User' ? 'User' : 'Shop';
  };

  const currentProfileType = getCurrentProfileType();
  const profileId = currentProfile === 'User' ? userId : sellerId;

  const handleClose = () => {
    dispatch(setNotificationSidebarOpen(false));
  };

  const handleOpenMessages = () => {
    dispatch(setNotificationSidebarOpen(false));
    setIsMessagesModalOpen(true);
  };

  const handleCloseMessages = () => {
    setIsMessagesModalOpen(false);
  };

  return (
    <>
      <SharedRightSlideout
        isOpen={isNotificationSidebarOpen}
        onClose={handleClose}
        title="Notifications"
        className="notification-shared-slideout"
        bodyClassName="notification-shared-slideout-body"
      >
        {profileId ? (
          <NotificationFeed
            profileId={profileId}
            profileType={currentProfileType}
            onClose={handleClose}
            onOpenMessages={handleOpenMessages}
          />
        ) : (
          <div className="notification-feed-empty">
            <p className="notification-feed-empty-message">Sign in to see notifications.</p>
          </div>
        )}
      </SharedRightSlideout>

      {isMessagesModalOpen && (
        <div className="messages-modal-overlay" onClick={handleCloseMessages}>
          <section
            className="messages-modal-content"
            role="dialog"
            aria-modal="true"
            aria-labelledby="messages-modal-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="messages-modal-close-button"
              onClick={handleCloseMessages}
              aria-label="Close messages"
            >
              &times;
            </button>
            <header className="messages-modal-titlebar">
              <p>Messages</p>
              <h2 id="messages-modal-title">Inbox</h2>
              <span>Read conversations and reply without leaving your profile settings.</span>
            </header>
            <div className="messages-modal-body">
              <UserInbox embedded />
            </div>
          </section>
        </div>
      )}
    </>
  );
}




